const baseUrl = process.env.REACT_APP_BASE_URL;

class BranchService {



    createBranch (countryId, name) {



        const token = localStorage.getItem('token');

        const requestData = {
            "name": name,
           
            "countryId": countryId
           
        }

        return fetch(baseUrl + '/manager/branch/create', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });

    }

    updateBranch (branchId, countryId, name) {



        const token = localStorage.getItem('token');

        const requestData = {
            "name": name,

            "countryId": countryId
           
        }

        return fetch(baseUrl + '/manager/branch/update/'+branchId, {
            method: 'PUT',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });

    }


    branchList (countryId, name) {



        const token = localStorage.getItem('token');

        const requestData = {
            "name": name,
           
            "countryId": countryId
           
        }

        return fetch(baseUrl + '/manager/branch/list', {
            method: 'POST',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            },
            body: JSON.stringify(requestData)
        });

    }


    fetchBranch (branchId) {



        const token = localStorage.getItem('token');

        
        return fetch(baseUrl + '/manager/branch/fetch/'+branchId, {
            method: 'GET',
            headers: {

                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token,
                'Accept': 'application/json',
            }
        });

    }


    setUserBranch(countryId, branchId){

        const token = localStorage.getItem('token');

        
        return fetch(baseUrl+'/manager/user/set/branch/'+countryId+'/'+branchId, {
            method : 'GET',
            headers: {

                'Content-Type' : 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization' : token,
                'Accept' : 'application/json',
            }
        });
    }

    setBranchOrderFromCustomerOrders(branchId,customerId, ){

        const token = localStorage.getItem('token');

        
        return fetch(baseUrl+'/manager/branch/set/from/customer/orders/'+branchId+'/'+customerId, {
            method : 'POST',
            headers: {

                'Content-Type' : 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization' : token,
                'Accept' : 'application/json',
            }
        });
    }


}
export default BranchService;